export default __webpack_public_path__ + "static/figma-styles-939a62c2654f37287d44e2673834727e.gif";